import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('site_alert', '.alert-close', (close) => {
  const alert = close.closest('.alert')
  let dismissed = parseInt(window.sessionStorage.getItem('alert-dismissed')) || false

  const adjustPadding = () => {
    document.body.style.paddingTop = alert.offsetHeight + 'px'
  }

  const value = sessionStorage.getItem('DisplayAlertBanner')
  if (value == null || value != 'false') {
    $('div.alert').addClass('is-open')
  }

  if (!dismissed) {
    alert.classList.add('is-open')
    //document.body.style.paddingTop = alert.offsetHeight - 4 + 'px';
    //window.addEventListener('resize', adjustPadding);
  } else {
    alert.classList.remove('is-open')
    alert.style.display = 'none'
  }

  addEvents(close, 'click enter', () => {
    alert.classList.remove('is-open')
    document.body.style.paddingTop = '0'
    window.sessionStorage.setItem('alert-dismissed', '1')
    window.removeEventListener('resize', adjustPadding)
    alert.style.display = 'none'
  })
})
